export const article = [
  {
    articleId: 22,
    url: "crear-varios-perfiles",
    category: {
      slug:"cuenta",
      name: "Mi cuenta"
    },
    title: "Crear varios perfiles",
    content: 
      <>
        <div className="row">
          <p>Tu cuenta puede tener hasta 6 perfiles. Los perfiles te permiten hacer seguimiento de lo que estás viendo (Continuar viendo) y lo que te gustaría ver (Favoritos). Para mayor información, visita Perfiles, Nuevo perfil y EDITAR PERFILES. </p>
        </div>
      </>
  }
];